/**
 * Smart Filtering – Fairtrade Mediathek (Horizon Integration)
 * Client-side filtering based on Metafield values.
 * Works with Horizon's main-collection product grid (.product-grid__item).
 *
 * 3-stufige Kaskade:
 *   Level 1 – fairtrade.filter   (immer sichtbar)
 *   Level 2 – fairtrade.format   (sichtbar wenn mind. 1 Filter aktiv)
 *   Level 3 – fairtrade.kampagne (sichtbar wenn mind. 1 Format aktiv)
 *
 * Renders into both desktop (.sf-controls / .sf-filter-area) and
 * mobile (.facets-mobile-wrapper) containers via delegated events.
 */
(function () {
  'use strict';

  const SELECTORS = {
    controls: '.sf-controls',
    grid: '.product-grid',
    item: '.product-grid__item',
    resultsCount: '[data-sf-results-count]',
    resetBtn: '.sf-summary__reset',
  };

  const LEVELS = [
    { key: 'filter',   pillCls: 'sf-pill',       dataAttr: 'data-filter',     activeCls: 'sf-pill--active' },
    { key: 'format',   pillCls: 'sf-pill--sub',   dataAttr: 'data-subfilter',  activeCls: 'sf-pill--active' },
    { key: 'kampagne', pillCls: 'sf-pill--sub3',  dataAttr: 'data-subfilter3', activeCls: 'sf-pill--active' },
  ];

  let products = [];
  let showCounts = true;
  let activeByLevel = [new Set(), new Set(), new Set()];

  function init() {
    const dataEl = document.getElementById('smart-filter-data');
    if (!dataEl) return;

    try {
      const data = JSON.parse(dataEl.textContent);
      const rawProducts = data.products || [];
      // Deduplicate by id (Feedback Nr. 79: Doppelte Produkte bei Kombi-Filtern)
      const seen = new Set();
      products = rawProducts.filter((p) => {
        const id = String(p.id);
        if (seen.has(id)) return false;
        seen.add(id);
        return true;
      });
      showCounts = data.showCounts !== false;
    } catch (e) {
      console.error('Smart Filter: Failed to parse product data', e);
      return;
    }

    renderFilterPills();
    bindEvents();
    applyFilters();
  }

  /* ---- Helpers ---- */
  function valueOf(p, key) {
    var val = p[key];
    if (val == null) return '';
    if (Array.isArray(val)) return val;
    if (typeof val === 'string') return val.trim();
    return String(val).trim();
  }

  function getCounts(productList, key) {
    const counts = {};
    productList.forEach((p) => {
      const val = valueOf(p, key);
      const values = Array.isArray(val) ? val : (val ? [val] : []);
      values.forEach((v) => {
        const trimmed = (v || '').trim();
        if (trimmed) counts[trimmed] = (counts[trimmed] || 0) + 1;
      });
    });
    return counts;
  }

  function filteredUpTo(levelIdx) {
    let list = products;
    for (let i = 0; i < levelIdx; i++) {
      const active = activeByLevel[i];
      if (active.size > 0) {
        const key = LEVELS[i].key;
        list = list.filter((p) => {
          const val = valueOf(p, key);
          if (Array.isArray(val)) {
            return val.some((v) => active.has((v || '').trim()));
          }
          return active.has(val);
        });
      }
    }
    return list;
  }

  function fullyFiltered() {
    return filteredUpTo(LEVELS.length);
  }

  /* ---- Render Level-1 pills into ALL pill containers ---- */
  function renderFilterPills() {
    const containers = document.querySelectorAll('[data-sf-pills-lvl1]');
    if (!containers.length) return;

    const counts = getCounts(products, LEVELS[0].key);
    const sorted = Object.keys(counts).sort((a, b) => a.localeCompare(b, 'de'));

    const html = sorted
      .map(
        (f) =>
          `<button class="sf-pill" data-filter="${escapeAttr(f)}" type="button">
            ${escapeHtml(f)}
            ${showCounts ? `<span class="sf-pill__count">${counts[f]}</span>` : ''}
          </button>`
      )
      .join('');

    containers.forEach((c) => { c.innerHTML = html; });
  }

  /* ---- Delegated event binding on document ---- */
  function bindEvents() {
    document.addEventListener('click', handleClick);

    // Sticky shadow on scroll
    const controls = document.querySelector(SELECTORS.controls);
    if (controls) {
      let ticking = false;
      window.addEventListener('scroll', () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            controls.classList.toggle('sf-controls--scrolled', window.scrollY > 10);
            ticking = false;
          });
          ticking = true;
        }
      });
    }
  }

  function handleClick(e) {
    // Level 1 pill
    var pill = e.target.closest('.sf-pill[data-filter]');
    if (pill && !pill.classList.contains('sf-pill--sub') && !pill.classList.contains('sf-pill--sub3')) {
      toggle(0, pill.dataset.filter);
      activeByLevel[1].clear();
      activeByLevel[2].clear();
      applyFilters();
      return;
    }

    // Level 2 pill
    var subPill = e.target.closest('.sf-pill--sub[data-subfilter]');
    if (subPill) {
      toggle(1, subPill.dataset.subfilter);
      activeByLevel[2].clear();
      applyFilters();
      return;
    }

    // Level 3 pill
    var sub3Pill = e.target.closest('.sf-pill--sub3[data-subfilter3]');
    if (sub3Pill) {
      toggle(2, sub3Pill.dataset.subfilter3);
      applyFilters();
      return;
    }

    // Summary tag close
    var closeBtn = e.target.closest('.sf-summary__tag-close');
    if (closeBtn) {
      var tag = closeBtn.closest('.sf-summary__tag');
      if (tag) {
        var lvl = parseInt(tag.dataset.level, 10);
        var val = tag.dataset.value;
        if (!Number.isNaN(lvl) && val) {
          activeByLevel[lvl].delete(val);
          for (var i = lvl + 1; i < LEVELS.length; i++) activeByLevel[i].clear();
          applyFilters();
        }
      }
      return;
    }

    // Reset
    if (e.target.closest(SELECTORS.resetBtn)) {
      activeByLevel.forEach(function(s) { s.clear(); });
      applyFilters();
    }
  }

  function toggle(levelIdx, val) {
    var set = activeByLevel[levelIdx];
    if (set.has(val)) set.delete(val);
    else set.add(val);
  }

  /* ---- Apply filters and update UI ---- */
  function applyFilters() {
    var filtered = fullyFiltered();
    var filteredIds = new Set(filtered.map(function(p) { return String(p.id); }));
    var hasActive = activeByLevel.some(function(s) { return s.size > 0; });

    document.querySelectorAll(SELECTORS.item).forEach(function(item) {
      var productId = item.dataset.productId;
      item.style.display = hasActive ? (filteredIds.has(productId) ? '' : 'none') : '';
    });

    updatePillStates();
    if (showCounts) updatePillCounts();
    updateSubRow(1);
    updateSubRow(2);
    updateAllSummaries();
    updateResultsCount(hasActive ? filtered.length : products.length);
    updateEmptyState(filtered.length);
  }

  /* ---- Pill active states (all containers) ---- */
  function updatePillStates() {
    document.querySelectorAll('.sf-pill[data-filter]').forEach(function(pill) {
      if (!pill.classList.contains('sf-pill--sub') && !pill.classList.contains('sf-pill--sub3')) {
        pill.classList.toggle('sf-pill--active', activeByLevel[0].has(pill.dataset.filter));
      }
    });
    document.querySelectorAll('.sf-pill--sub[data-subfilter]').forEach(function(pill) {
      pill.classList.toggle('sf-pill--active', activeByLevel[1].has(pill.dataset.subfilter));
    });
    document.querySelectorAll('.sf-pill--sub3[data-subfilter3]').forEach(function(pill) {
      pill.classList.toggle('sf-pill--active', activeByLevel[2].has(pill.dataset.subfilter3));
    });
  }

  /* ---- Update Level-1 pill counts ---- */
  function updatePillCounts() {
    document.querySelectorAll('.sf-pill[data-filter]').forEach(function(pill) {
      if (pill.classList.contains('sf-pill--sub') || pill.classList.contains('sf-pill--sub3')) return;
      var filterVal = pill.dataset.filter;
      var matching = products.filter(function(p) {
        var val = valueOf(p, LEVELS[0].key);
        if (Array.isArray(val)) return val.some(function(v) { return (v || '').trim() === filterVal; });
        return val === filterVal;
      });
      for (var i = 1; i < LEVELS.length; i++) {
        var set = activeByLevel[i];
        if (set.size > 0) {
          var key = LEVELS[i].key;
          matching = matching.filter(function(p) {
            var v = valueOf(p, key);
            if (Array.isArray(v)) return v.some(function(x) { return set.has((x || '').trim()); });
            return set.has(v);
          });
        }
      }
      var countEl = pill.querySelector('.sf-pill__count');
      if (countEl) countEl.textContent = matching.length;
    });
  }

  /* ---- Sub-row rendering into ALL matching containers ---- */
  function updateSubRow(levelIdx) {
    var isLvl3 = levelIdx === 2;
    var rowAttr = isLvl3 ? '[data-sf-sub-lvl3]' : '[data-sf-sub-lvl2]';
    var pillAttr = isLvl3 ? '[data-sf-sub-lvl3] .sf-sub-row__pills' : '[data-sf-sub-lvl2] .sf-sub-row__pills';
    var rows = document.querySelectorAll(rowAttr);
    var pillEls = document.querySelectorAll(pillAttr);

    var prevActive = activeByLevel[levelIdx - 1].size > 0;
    if (!prevActive) {
      rows.forEach(function(r) { r.classList.remove('sf-sub-row--visible'); });
      activeByLevel[levelIdx].clear();
      if (levelIdx === 1) {
        document.querySelectorAll('[data-sf-sub-lvl3]').forEach(function(r) {
          r.classList.remove('sf-sub-row--visible');
        });
        activeByLevel[2].clear();
      }
      return;
    }

    var sourceProducts = filteredUpTo(levelIdx);
    var counts = getCounts(sourceProducts, LEVELS[levelIdx].key);
    var sorted = Object.keys(counts).sort(function(a, b) { return a.localeCompare(b, 'de'); });

    if (sorted.length === 0) {
      rows.forEach(function(r) { r.classList.remove('sf-sub-row--visible'); });
      return;
    }

    var cls = isLvl3 ? 'sf-pill sf-pill--sub3' : 'sf-pill sf-pill--sub';
    var dataAttrName = isLvl3 ? 'data-subfilter3' : 'data-subfilter';
    var activeSet = activeByLevel[levelIdx];

    var html = sorted
      .map(function(f) {
        return '<button class="' + cls + (activeSet.has(f) ? ' sf-pill--active' : '') + '" ' + dataAttrName + '="' + escapeAttr(f) + '" type="button">'
          + escapeHtml(f)
          + (showCounts ? '<span class="sf-pill__count">' + counts[f] + '</span>' : '')
          + '</button>';
      })
      .join('');

    pillEls.forEach(function(el) { el.innerHTML = html; });
    rows.forEach(function(r) { r.classList.add('sf-sub-row--visible'); });
  }

  /* ---- Active filter summary into ALL summary containers ---- */
  function updateAllSummaries() {
    var summaries = document.querySelectorAll('[data-sf-summary]');
    var hasActive = activeByLevel.some(function(s) { return s.size > 0; });

    summaries.forEach(function(summary) {
      summary.classList.toggle('sf-summary--visible', hasActive);

      if (!hasActive) {
        summary.innerHTML = '';
        return;
      }

      var html = '';
      LEVELS.forEach(function(lvl, idx) {
        activeByLevel[idx].forEach(function(v) {
          html += '<span class="sf-summary__tag" data-level="' + idx + '" data-value="' + escapeAttr(v) + '">'
            + escapeHtml(v)
            + '<button class="sf-summary__tag-close" type="button" aria-label="Filter entfernen: ' + escapeAttr(v) + '">&times;</button>'
            + '</span>';
        });
      });
      html += '<button class="sf-summary__reset" type="button">Alle zur\u00FCcksetzen</button>';
      summary.innerHTML = html;
    });
  }

  /* ---- Results count ---- */
  function updateResultsCount(count) {
    document.querySelectorAll(SELECTORS.resultsCount).forEach(function(el) {
      el.innerHTML = '<strong>' + count + '</strong> Materialien gefunden';
    });
  }

  /* ---- Empty state ---- */
  function updateEmptyState(count) {
    var grid = document.querySelector(SELECTORS.grid);
    if (!grid) return;

    var emptyEl = grid.querySelector('.sf-empty');
    if (count === 0) {
      if (!emptyEl) {
        emptyEl = document.createElement('li');
        emptyEl.className = 'sf-empty';
        emptyEl.innerHTML = 'Keine Materialien f\u00FCr diese Filterauswahl gefunden.';
        grid.appendChild(emptyEl);
      }
      emptyEl.hidden = false;
    } else if (emptyEl) {
      emptyEl.hidden = true;
    }
  }

  /* ---- Escape helpers ---- */
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function escapeAttr(str) {
    return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
